/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "122baab1aa7d4582ca0029fd3e83192238baddc5";
